export default "__VITE_ASSET__qhIWyov0__"